import { render } from "./PollBuilder.vue?vue&type=template&id=07f37e20"
import script from "./PollBuilder.vue?vue&type=script&lang=js"
export * from "./PollBuilder.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/PollBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f37e20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f37e20', __exports__)) {
    api.reload('07f37e20', __exports__)
  }
  
  module.hot.accept("./PollBuilder.vue?vue&type=template&id=07f37e20", () => {
    api.rerender('07f37e20', render)
  })

}


export default __exports__